import { Stack } from "../..";
import { IEditCommand } from "./IEditCommand";

export class EditCommandManager<T> {
  constructor(max?: number) {
    this._done = new Stack(max);
    this._undone = new Stack(max);
  }

  private readonly _done: Stack<IEditCommand<T>>;
  private readonly _undone: Stack<IEditCommand<T>>;

  get hasDoneCommands(): boolean {
    return (0 < this._done.count);
  }

  get hasUndoneCommands(): boolean {
    return (0 < this._undone.count);
  }

  do(source: T, command: IEditCommand<T>): void {
    command.do(source);
    this._done.push(command);
    this._undone.clear();
  }

  undo(source: T): void {
    if (!this.hasDoneCommands) {
      return;
    }
    const command = this._done.pop();
    command.undo(source);
    this._undone.push(command);
  }

  redo(source: T): void {
    if (!this.hasUndoneCommands) {
      return;
    }
    const command = this._undone.pop();
    command.do(source);
    this._done.push(command);
  }
}
